import React from "react";
import Layout from "@/components/Layout";
import { OPERATOR } from "@/lib/operator";

const SECTIONS = [
  {
    h: "1. Správce osobních údajů",
    p: [
      `Správcem osobních údajů ve smyslu Nařízení (EU) 2016/679 (GDPR) je společnost ${OPERATOR.company}, IČO ${OPERATOR.icPretty}, se sídlem ${OPERATOR.address}, výhradní provozovatel portálu STAVBOŠ.`,
      `Kontakt pro otázky ohledně zpracování: ${OPERATOR.email}`,
    ],
  },
  {
    h: "2. Jaké údaje zpracováváme",
    p: [
      "• E-mailovou adresu, přezdívku, volitelně telefonní číslo a profilovou fotografii.",
      "• Obsah a fotografie inzerátu, lokalitu, výrobní/EAN/VIN čísla.",
      "• Zprávy v chatu mezi uživateli, e-maily odeslané přes odpovědní formulář.",
      "• Údaje o platbě (anonymizované – platbu zpracovává Stripe, neukládáme údaje o platebních kartách).",
    ],
  },
  {
    h: "3. Účel zpracování",
    p: [
      "Provoz inzertního portálu, komunikace mezi inzerentem a zájemcem, vyhodnocení podvodných inzerátů, účetní povinnosti u TOPování.",
    ],
  },
  {
    h: "4. Doba zpracování",
    p: [
      "Inzeráty a profil zpracováváme po dobu existence účtu, případně 12 měsíců po smazání pro účely odhalení podvodů.",
      "Údaje o platbách uchováváme po dobu vyžadovanou účetními předpisy (až 10 let).",
    ],
  },
  {
    h: "5. Vaše práva",
    p: [
      "Máte právo na přístup, opravu, výmaz, omezení zpracování, přenositelnost dat a podání stížnosti u Úřadu pro ochranu osobních údajů.",
      "Žádosti zasílejte na stavbos@post.cz – vyřizujeme do 30 dnů.",
    ],
  },
  {
    h: "6. Cookies a analytika",
    p: [
      "Portál používá pouze technické cookies nezbytné pro provoz (přihlášení, košík TOP plateb).",
      "V budoucnu může být přidán analytický nástroj — uživatel bude informován cookie lištou.",
    ],
  },
  {
    h: "7. Předávání třetím stranám",
    p: [
      "Údaje nepředáváme třetím stranám s výjimkou: platební brány Stripe (zpracování plateb), e-mailové služby Resend (rozesílání transakčních e-mailů, plánováno).",
    ],
  },
];

export default function GdprPage() {
  return (
    <Layout>
      <article className="max-w-3xl stb-card p-6" data-testid="gdpr-page">
        <h1 className="stb-h text-3xl text-white">Ochrana osobních údajů (GDPR)</h1>
        <p className="stb-label mt-1">Aktualizováno 19. 9. 2026</p>
        <hr className="stb-divider" />
        {SECTIONS.map((s, i) => (
          <section key={i} className="mb-5">
            <h2 className="stb-h text-xl text-[#FF6B00]">{s.h}</h2>
            {s.p.map((t, j) => (
              <p key={j} className="text-[#E5E5E5] mt-2 leading-relaxed">{t}</p>
            ))}
          </section>
        ))}
      </article>
    </Layout>
  );
}
